import React, { memo } from 'react'
import { FieldErrors } from 'react-hook-form'
import ControlledCheckbox from 'transfix-form/components/ControlledCheckbox'
import ControlledTextInput from 'transfix-form/components/ControlledTextInput'
import Grid from 'transfix-ui/core/Grid'
import Typography from 'transfix-ui/core/Typography'
import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import { useCreateShipmentFormContext } from '../../../context'
import { TOpenDeckSchema } from '../../../schema/EquipmentDetailsSchema/EquipmentOpenDeckSchema'
import { getEquipmentAttributeErrorMessage } from '../../../utils'

export interface IOpenDeckEquipmentFormSectionProps {}

type TOpenDeckSchemaErrors = FieldErrors<TOpenDeckSchema>

const getNumberValue = (val: string) => Number(val) || undefined

const OpenDeckEquipmentFormSection = memo<IOpenDeckEquipmentFormSectionProps>(() => {
  /**
   * Form Context
   */
  const { control, errors } = useCreateShipmentFormContext()
  const { equipmentAttributes } = errors || {}
  const equipmentAttributesErrors = equipmentAttributes as TOpenDeckSchemaErrors

  const getErrorMessage = (keyName: keyof TOpenDeckSchemaErrors) => {
    return getEquipmentAttributeErrorMessage<TOpenDeckSchema>(equipmentAttributesErrors, keyName)
  }

  return (
    <Grid container spacing={2} data-test='open-deck-equipment-form-section'>
      <Grid item xs={12} md={4}>
        <Typography variant='subtitle1'>Securing Options</Typography>
        <div>
          <ControlledCheckbox
            control={control}
            name={`equipmentAttributes.${IEquipmentAttributeTypes.chains}`}
            CheckboxProps={{
              label: 'Chains',
              dataTest: 'chains-field',
            }}
          />
        </div>
        <div>
          <ControlledCheckbox
            control={control}
            name={`equipmentAttributes.${IEquipmentAttributeTypes.tarp}`}
            CheckboxProps={{
              label: 'Tarp',
              dataTest: 'tarp-field',
            }}
          />
        </div>
        <div>
          <ControlledCheckbox
            control={control}
            name={`equipmentAttributes.${IEquipmentAttributeTypes.coil_rack}`}
            CheckboxProps={{
              label: 'Coil Rack',
              dataTest: 'coil-rack-field',
            }}
          />
        </div>
        <div>
          <ControlledCheckbox
            control={control}
            name={`equipmentAttributes.${IEquipmentAttributeTypes.ratchet_straps}`}
            CheckboxProps={{
              label: 'Ratchet Straps',
              dataTest: 'ratchet-straps-field',
            }}
          />
        </div>
        <div>
          <ControlledTextInput
            control={control}
            name={`equipmentAttributes.${IEquipmentAttributeTypes.straps}`}
            mutateValue={getNumberValue}
            TextInputProps={{
              type: 'number',
              label: 'Straps',
              placeholder: '#',
              dataTest: 'straps-field',
              error: !!getErrorMessage(IEquipmentAttributeTypes.straps),
              validationMessage: getErrorMessage(IEquipmentAttributeTypes.straps),
            }}
          />
        </div>
      </Grid>
    </Grid>
  )
})

export default OpenDeckEquipmentFormSection
